var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGhana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.034C0 17.9911 0.352063 19.8659 0.995188 21.5992L16 22.2949L31.0048 21.5993C31.648 19.8659 32 17.9911 32 16.034C32 14.0769 31.648 12.2021 31.0048 10.4688L16 9.77315L0.995188 10.4688C0.352063 12.2021 0 14.0769 0 16.034H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.0341797C9.12061 0.0341797 3.25593 4.37618 0.995239 10.469H31.0049C28.7442 4.37618 22.8795 0.0341797 16.0001 0.0341797V0.0341797Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0049 21.5994H0.995239C3.25593 27.6921 9.12061 32.0342 16.0001 32.0342C22.8795 32.0342 28.7442 27.6921 31.0049 21.5994Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 10.469L17.3811 14.7202H21.8516L18.2351 17.3479L19.6164 21.5993L15.9998 18.9718L12.3833 21.5993L13.7648 17.3479L10.1483 14.7202H14.6186L15.9998 10.469Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhana);
export default __webpack_public_path__ + "static/media/ghana.d7a94769.svg";
export { ForwardRef as ReactComponent };